<template>
    <b-modal
        :id="`modal-form-${modalId}`"
        ref="modal"
        :title="modalTitle"
        class="h-100"
        dialog-class="h-100"
        content-class="h-100"
        body-class="h-100 overflow-hidden"
        size="xl"
        cancel-variant="light"
        ok-variant="primary"
        :cancel-title="$t('cancel')"
        :ok-title="$t('saveSet')"
        :busy="submitting"
        static
        no-close-on-esc
        ok-only
        :ok-disabled="$v.$invalid || submitting"
        @ok.prevent="handleSubmit()"
        @show="resetData()"
        @hidden="resetData()"
    >
        <b-overlay :show="submitting" opacity="0" class="h-100 overflow-hidden">
            <b-form class="overflow-hidden h-100 d-flex flex-column" @submit.prevent>

                <FormValidator :validator="$v.form.producerProduct" form-group v-slot="slotProps" :label="`1. ${$t('chooseYourProduct')}`" label-class="font-size-16">
                    <Multiselect
                        ref="MultiselectOwnProduct"
                        v-model="currentProducerProduct"
                        :fetch-options-function="fetchProducerProduct"
                        :placeholder="$t('findProduct')"
                        :selected-options-label="$t('selectedProducts')"
                        preserve-search
                        asynchronous
                        track-by="id"
                        label="name"
                        select-label=""
                        :disabled="submitting && !loadingProducerProduct"
                        show-selected
                        :multiple="false"
                        :clear-on-select="false"
                        :state="slotProps.state"
                        @inputTrackBy="form.producerProduct = $event"
                        @loading="loadingProducerProduct = $event"
                    >
                        <template #option="props">
                            <ProducerProductItem :item="props.option" />
                        </template>
                    </Multiselect>
                </FormValidator>

                <b-form-group v-if="currentProducerProduct">
                    <ProducerProductItem :item="currentProducerProduct" btn-remove @remove="item => removeItem(item, 'MultiselectOwnProduct')" />
                </b-form-group>


                <b-form-group :label="`2. ${$t('chooseCompetitiveProducts')}`" label-class="font-size-16">

                    <b-form-radio-group
                        v-model="competitionType"
                        :options="competitionTypeOptions"
                        buttons
                        button-variant="primary"
                        size="sm"
                        class="mb-2"
                    />

                    <FormValidator v-show="competitionType === 'global'" :validator="$v.form.globalProducts" v-slot="slotProps" :attribute="$t('chooseYourProduct')">

                        <Multiselect
                            ref="MultiselectGlobalProducts"
                            v-model="currentGlobalProducts"
                            :fetch-options-function="fetchDescribedProducts"
                            :placeholder="$t('findProduct')"
                            :selected-options-label="$t('selectedProducts')"
                            preserve-search
                            asynchronous
                            track-by="id"
                            label="name"
                            select-label=""
                            :disabled="submitting && !loadingDescribedProducts"
                            show-selected
                            :multiple="true"
                            :show-checkboxes="true"
                            :clear-on-select="false"
                            :close-on-select="false"
                            :state="slotProps.state"
                            @inputTrackBy="form.globalProducts = $event"
                            @loading="loadingDescribedProducts = $event"
                        >
                            <template #optionLabel="props">
                                <ProducerProductItem :item="props.option" />
                            </template>
                        </Multiselect>

                    </FormValidator>

                    <FormValidator v-show="competitionType === 'own'" :validator="$v.form.producerProducts" v-slot="slotProps" :attribute="$t('chooseYourProduct')">

                        <Multiselect
                            ref="MultiselectOwnProducts"
                            v-model="currentProducerProducts"
                            :fetch-options-function="fetchProducerProducts"
                            :placeholder="$t('findProduct')"
                            :selected-options-label="$t('selectedProducts')"
                            preserve-search
                            asynchronous
                            track-by="id"
                            label="name"
                            select-label=""
                            :disabled="submitting && !loadingProducerProducts"
                            show-selected
                            :multiple="true"
                            :show-checkboxes="true"
                            :clear-on-select="false"
                            :close-on-select="false"
                            :state="slotProps.state"
                            @inputTrackBy="form.producerProducts = $event"
                            @loading="loadingProducerProducts = $event"
                        >
                            <template #optionLabel="props">
                                <ProducerProductItem :item="props.option" />
                            </template>
                        </Multiselect>

                    </FormValidator>

                </b-form-group>


                <div class="overflow-auto h-auto">
                    <b-form-group v-for="item in currentGlobalProducts || []" :key="item.id">
                        <ProducerProductItem :item="item" btn-remove @remove="item => removeItem(item, 'MultiselectGlobalProducts')" />
                    </b-form-group>

                    <b-form-group v-for="item in currentProducerProducts || []" :key="item.id">
                        <ProducerProductItem :item="item" btn-remove @remove="item => removeItem(item, 'MultiselectOwnProducts')" />
                    </b-form-group>
                </div>


            </b-form>
        </b-overlay>
    </b-modal>
</template>



<script>
    import { required, requiredIf } from 'vuelidate/lib/validators';
    import ModalFormMixin from '@/mixins/modalFormMixin';
    import FormValidator from '@/components/common/FormValidator.vue';
    import Multiselect from '@/components/common/Multiselect.vue';
    import ProducerProductItem from './ProducerProductItem.vue';

    export default {
        name: 'ModalForm',
        mixins: [ModalFormMixin],
        components: {
            FormValidator,
            Multiselect,
            ProducerProductItem,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestProducerProducts: this.$req('space/ProducerProducts'),
                requestDescribedProducts: this.$req('product/DescribedProducts'),
                modalId: 'competitive-analysis',
                currentProducerProduct: null,
                currentProducerProducts: null,
                currentGlobalProducts: null,
                form: {
                    producerProduct: null,
                    producerProducts: null,
                    globalProducts: null,
                },
                loadingProducerProduct: false,
                loadingProducerProducts: false,
                loadingDescribedProducts: false,
                competitionType: 'global',
            };
        },
        computed: {
            itemId() {
                return this.item?.reportId || null;
            },
            createAction() {
                return this.$req('CompetitionReport/SpacesCompetitionReportSet').post;
            },
            updateAction() {
                return this.$req('CompetitionReport/CompetitionReportSet').patch;
            },
            modalTitle() {
                return this.$t('createASetOfProducts');
            },
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
            userId() {
                return this.$store.state.auth.user.id;
            },
            formValidations() {
                return {
                    form: {
                        producerProduct: { required },
                        producerProducts: { required: requiredIf(form => !form.globalProducts?.length) },
                        globalProducts: { required: requiredIf(form => !form.producerProducts?.length) },
                    },
                };
            },
            apiParams() {
                const apiParams = {
                    requestParams: this.requestParams,
                    urlParams: { spaceId: this.spaceId, id: this.itemId },
                };
                return apiParams;
            },
            competitionTypeOptions() {
                return [
                    { text: this.$t('globalProduct'), value: 'global' },
                    { text: this.$t('yourProduct'), value: 'own' },
                ];
            },
        },
        methods: {
            onInit(item) {
                this.resetData();
                this.initItem(item);
                this.initFormValues();
                this.afterInitFormValues();
            },
            initItem(item) {
                this.item = item;
                this.currentProducerProduct = item?.producerProduct || null;
                this.currentProducerProducts = item?.producerProducts || [];
                this.currentGlobalProducts = item?.globalProducts || [];
            },
            initFormValues() {
                this.form = {
                    producerProduct: this.currentProducerProduct?.id ?? null,
                    producerProducts: this.currentProducerProducts.map(prod => prod.id),
                    globalProducts: this.currentGlobalProducts.map(prod => prod.id),
                };
            },
            afterInitFormValues() {
                this.competitionType = this.form.globalProducts?.length ? 'global' : 'own';
            },
            fetchProducerProduct({ search }) {
                return this.requestProducerProducts.id('own').get({ urlParams: { spaceId: this.spaceId }, requestParams: { search } });
            },
            fetchProducerProducts({ search }) {
                return this.requestProducerProducts.id('competition').get({ urlParams: { spaceId: this.spaceId }, requestParams: { search } });
            },
            fetchDescribedProducts({ search }) {
                const publisher = this.userId;
                return this.requestDescribedProducts.get({ requestParams: { search, publisher } });
            },
            refreshData() {
                // this.parentComponent.fetchData();
                this.parentComponent.fetchReportSet();
            },
            removeItem(item, refName) {
                const multiselect = this.$refs[refName];
                if (multiselect) {
                    multiselect.removeElement(item);
                }
            },
        },
        // created() {
        //     this.$root.$on(`modal-form-${this.modalId}`, this.initItem);
        // },
        // beforeDestroy() {
        //     this.$root.$off(`modal-form-${this.modalId}`);
        // },
    };
</script>
